import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./modal.html";
import { getFocusTrap } from '~/modules/helpers/focusTrap';
import { selectSharedLabels, WireI18n } from '~/modules/stores/i18nStore';

/**
 * Modal to display varying content.
 * It exposes two slots called 'main-content' and 'footer' to display given html
 * @param {string[]} focusableElements All the focusable elements query selectors inside the given slots.
 * @param {string} title The title to display on the modal alongside the close button.
 */
class Modal extends LightningElement {
  constructor(...args) {
    super(...args);
    this.title = '';
    this.closedFocusTarget = void 0;
    this.autoFocusOff = false;
    this.sharedLabels = void 0;
  }
  connectedCallback() {
    // This will keep the body from scrolling while the modal is open.
    const styles = document.body.getAttribute('style') || '';
    document.body.setAttribute('style', styles.concat(' overflow-y: hidden;'));
  }
  renderedCallback() {
    const container = this.modalContainerRef;
    if (!container) {
      return;
    }
    this.focusTrap = getFocusTrap(container);
    this.focusFirstInput();
  }
  disconnectedCallback() {
    const styles = document.body.getAttribute('style');
    // @ts-expect-error * Automated Type Error Fix
    document.body.setAttribute('style', styles.replace(' overflow-y: hidden;', ''));
  }
  get modalContainerRef() {
    // @ts-expect-error * Automated Type Error Fix
    return this.template.querySelector('.modal');
  }
  get closeIconDescription() {
    return this.sharedLabels.close;
  }
  closeModal() {
    this.dispatchEvent(new CustomEvent('close', {
      detail: {
        closedFocusTarget: this.closedFocusTarget
      }
    }));
  }

  // @ts-expect-error * Automated Type Error Fix
  handleNextFocus(event) {
    const {
      focusNext
    } = this.focusTrap;
    const {
      shouldPreventDefault
    } = focusNext();
    if (shouldPreventDefault) {
      event.preventDefault();
    }
  }

  // @ts-expect-error * Automated Type Error Fix
  handlePrevFocus(event) {
    const {
      focusPrevious
    } = this.focusTrap;
    const {
      shouldPreventDefault
    } = focusPrevious();
    if (shouldPreventDefault) {
      event.preventDefault();
    }
  }

  // @ts-expect-error * Automated Type Error Fix
  handleInputKey(event) {
    if (event.key === 'Escape') {
      this.closeModal();
    }
    if (event.key === 'Tab') {
      if (event.shiftKey) {
        this.handlePrevFocus(event);
      } else {
        this.handleNextFocus(event);
      }
    }
  }
  focusFirstInput() {
    if (this.autoFocusOff || !this.focusTrap) {
      return;
    }
    // If more than one focusable element exists, focus the second one.
    // If there's only one focusable element, it's the modal's close button, and it will be focused.
    if (this.focusTrap.getFocusableElementsQuantity() > 1) {
      this.focusTrap.focusElementByIndex(1);
      return;
    }
    this.focusTrap.focusFirstElement();
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Modal, {
  publicProps: {
    title: {
      config: 0
    },
    closedFocusTarget: {
      config: 0
    },
    autoFocusOff: {
      config: 0
    }
  },
  wire: {
    sharedLabels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: selectSharedLabels
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(Modal, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;